module.exports = __webpack_public_path__ + "static/media/NHS.d963a616.png";